import { contactInfo } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">
            <i className="ri-mail-send-line text-primary-500 mr-2"></i>
            联系我们
          </h2>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
            {contactInfo.description}
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <div className="flex items-center gap-3 bg-background-50 rounded-xl px-6 py-4">
              <span className="w-10 h-10 flex items-center justify-center bg-primary-100 text-primary-500 rounded-full">
                <i className="ri-mail-line text-lg"></i>
              </span>
              <div className="text-left">
                <div className="text-xs text-foreground-500">投稿邮箱</div>
                <div className="text-sm font-medium text-foreground-800">{contactInfo.email}</div>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-background-50 rounded-xl px-6 py-4">
              <span className="w-10 h-10 flex items-center justify-center bg-accent-100 text-accent-600 rounded-full">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <div className="text-left">
                <div className="text-xs text-foreground-500">微信联系</div>
                <div className="text-sm font-medium text-foreground-800">{contactInfo.wechat}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}